<!-- Modal -->
<button hidden #newPassModal type="button" class="btn btn-secondary" data-toggle="modal" data-target="#newPassModal"></button>

<div class="modal fade" id="newPassModal" tabindex="-1" role="dialog" aria-labelledby="newPassModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="newPassModalLabel">Nueva contraseña</h5>
            <!-- <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button> -->
        </div>
        <form *ngIf="userData" [formGroup]="newPassForm" (ngSubmit)="setNewPass()">
        <div class="modal-body" *ngIf="!showSuccesfullMsg">
            <div class="form-group">
                <label for="UserName">Email</label>
                <input type="text" class="form-control" id="UserName" formControlName="UserName">
            </div>

            <div class="form-group mt-2">
                <app-password-check [password]="password" (passActive)="checkPass($event)"></app-password-check>
            </div> 

            <div class="form-group">
                <label for="password">Contraseña</label>
                <input type="password"  class="form-control" id="password" formControlName="NewPwd" (input)="checkPassword()">
            </div> 
             
        </div>
        <div *ngIf="showSuccesfullMsg " class="alert alert-success" role="alert">
            Contraseña actualizada exitosamente...
        </div>

        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>

        <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
            Error intente luego...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button [disabled]="!validPass" *ngIf="!showSuccesfullMsg" type="submit" class="btn btn-primary">Guardar</button>
        </div>
        </form>
        </div>
    </div>
    </div>